import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

import { getUserTimezone } from './getUserTimezone';

export const getFilterEndOfDay = (date: Date) => {
  const userTimezone = getUserTimezone();
  // Форматируем дату в строку YYYY-MM-DD, затем создаем её в таймзоне пользователя
  const dateString = dayjs(date).format('YYYY-MM-DD');
  return dayjs.tz(dateString, userTimezone).endOf('day').utc().toISOString();
};
